export default "../fonts/shop_icon.svg";